import { render, staticRenderFns } from "./EwfLogo.vue?vue&type=template&id=9bd6594a&"
import script from "./EwfLogo.vue?vue&type=script&lang=js&"
export * from "./EwfLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports